import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { startWith, map, filter, takeUntil } from 'rxjs/operators';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { Loading } from './loading/loading';
import { DialogStatus } from './dialog-status/dialog-status';
import { SettingsService } from '../settings/settings.service';


@Component({
  selector: 'app-ficha-inversionista',
  imports: [Loading,MatTabsModule, 
    MatDialogModule,MatAutocompleteModule,
    FormsModule,MatDatepickerModule,MatRadioModule,
    MatCheckboxModule, MatCardModule, MatButtonModule,
     MatIconModule, MatFormFieldModule, MatInputModule, 
     MatSelectModule, ReactiveFormsModule, CommonModule, 
     MatProgressSpinnerModule],
  templateUrl: './ficha-inversionista.component.html',
  styleUrl: './ficha-inversionista.component.less',
  standalone: true
})
export class FichaInversionistaComponent implements OnInit, OnChanges, OnDestroy {

  tubos: any[] = [];
  selectedTuboId: number | null = null;
  selectedTabIndex: number = 0;

  @Input() company_id:any;
  @Input() panelMode:boolean=false;
  @Input() parent:any;

  step:any=0;

  opcion_seleccionada: string="";
  tipo_persona: string[] = ['Persona natural', 'Persona jurídica'];
  formGroup: FormGroup;
  formGroup2: FormGroup;
  formGroup3: FormGroup;
  formGroup4: FormGroup;
  formGroup5: FormGroup;

  //persona jurifica
  valForm: FormGroup;
  valForm2: FormGroup;
  valForm4: FormGroup;
  constructor(private _formBuilder:FormBuilder, private settings:SettingsService, private dialog:MatDialog){

    //Persona natural
    this.formGroup = this._formBuilder.group({
      rut: [null , [Validators.required]],
      name: [null, [Validators.required]],
      fecha_nacimiento: [null, [Validators.required]],
      nacionalidad: [null, [Validators.required]],
      phone_number: [null, [Validators.required]],
      email: [null, [Validators.email]],
      direccion: [null, [Validators.required]],
      estado_civil: [null, [Validators.required]],
      region_id: [null],
      comuna_id: [null],
      phone_code: new FormControl('+56', Validators.required),
      countryFilterCtrl: new FormControl('')
    })

    //Persona juridica
    this.valForm = this._formBuilder.group({
      rut: [null , [Validators.required]],
      razon_social: [null, [Validators.required]],
      direccion: [null, [Validators.required]],
      giro: [null, [Validators.required]],
      email: [null, [Validators.email]],
    })

    //persona juridica
    this.valForm2 = this._formBuilder.group({
      rut: [null , [Validators.required]],
      name: [null, [Validators.required]],
      fecha_nacimiento: [null, [Validators.required]],
      nacionalidad: [null, [Validators.required]],
      phone_number: [null, [Validators.required]],
      email: [null, [Validators.email]],
      direccion: [null, [Validators.required]],
      cargo: [null, [Validators.required]],
      estado_civil: [null, [Validators.required]],
      region_empresa_id: [null],
      comuna_empresa_id: [null],
      phone_code: new FormControl('+56', Validators.required),
      countryFilterCtrl: new FormControl(''),
      profesion: [null, [Validators.required]],
    })

    //Persona natural
    this.formGroup2 = this._formBuilder.group({
      situacion_laboral: [null , [Validators.required]],
      business_name: [null],
      profesion: [null, [Validators.required]]
    })

    this.formGroup3 = this._formBuilder.group({
      banco_id: [null , [Validators.required]],
      cuenta_id: [null , [Validators.required]],
      rut: [null , [Validators.required]],
      titular: [null , [Validators.required]],
      numero_cuenta: [null , [Validators.required]],
      autorizar_terceros: [null]
    })

    //Persona natural
    this.formGroup4 = this._formBuilder.group({
      0: [false],
      1: [false],
      2: [false],
      3: [false],
      4: [false],
      5: [false]
    })

    //Persona juridica
    this.valForm4 = this._formBuilder.group({
      0: [false],
      1: [false],
      2: [false],
      3: [false],
      4: [false]
    })


    this.formGroup5 = this._formBuilder.group({
      0: [false],
      1: [false],
      2: [false],
    })
  }

  continuar_origen:boolean=true;
  continuar_declaracion:boolean=true;
  loading:boolean=true;
  private yaInicializado = false;

  @ViewChild('searchInput') searchInput!: ElementRef;
  private _destroy$ = new Subject<void>();

  async onTuboChange(index: number) {
    this.selectedTabIndex = index;
    this.selectedTuboId = this.tubos[index].tubo_id;
    await this.inicializarFicha();
  }

  async ngOnInit() {

    this.getTubos();

    await this.getPhonePrefix();
    await this.getDistricts();
    await this.estado_civil();
    await this.load_bancos();
    await this.load_cuentas();

    this.formGroup.controls['countryFilterCtrl'].valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(value => this.filterCountries(value ?? ''));

    this.valForm2.controls['countryFilterCtrl'].valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(value => this.filterCountries(value ?? ''));



    this.inicializarFicha();


    this.yaInicializado = true;
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  async getTubos() {
    try {
      const bd: any = await this.settings.get_query(1, '/cliente-inversionista/tubos/');
      this.tubos = bd._body.info.tubos;
      if (this.tubos.length > 0) {
        this.selectedTuboId = this.tubos[0].tubo_id;
      }
    } catch (error) {
      console.error('Error al obtener tubos:', error);
      this.tubos = [];
    }
  }

  private filterCountries(search: string) {
    const term = search.toLowerCase().trim();
    this.filteredCountries = !term
      ? [...this.COUNTRIES]
      : this.COUNTRIES.filter(c =>
          c.name.toLowerCase().includes(term) ||
          c.dialCode.includes(term)
        );
  }

  onSelectOpened(opened: boolean) {
    if (opened) {
      this.formGroup.controls['countryFilterCtrl'].setValue('');
      setTimeout(() => this.searchInput?.nativeElement?.focus(), 100);
    }
  }

  onSelectOpened2(opened: boolean) {
    if (opened) {
      this.valForm2.controls['countryFilterCtrl'].setValue('');
      setTimeout(() => this.searchInput?.nativeElement?.focus(), 100);
    }
  }

  onCountryChange(event: any) {
    // Limpiar el número al cambiar de país (opcional)
    this.formGroup.get('phone')?.setValue('');
  }

  @Input() modificar:boolean=false;
  ngOnChanges(changes: SimpleChanges): void {

    if (changes['selectedTuboId'] && changes['selectedTuboId'].currentValue) {

      if (this.yaInicializado) {
        this.formGroup.reset();
        this.formGroup2.reset();
        this.formGroup3.reset();
        this.formGroup4.reset();
        this.formGroup5.reset();
        this.valForm.reset();
        this.valForm2.reset();
        this.valForm4.reset();
        this.step = 0;
        this.opcion_seleccionada = "";

        this.formGroup.controls['countryFilterCtrl'].valueChanges
          .pipe(takeUntil(this._destroy$))
          .subscribe(value => this.filterCountries(value ?? ''));

        this.valForm2.controls['countryFilterCtrl'].valueChanges
          .pipe(takeUntil(this._destroy$))
          .subscribe(value => this.filterCountries(value ?? ''));

        this.inicializarFicha();
      }

    }

  }

  private async inicializarFicha() {
  if (this.selectedTuboId) {
    await this.get_ficha();
  }
}

  estado_civil_array:any[]=[];
  async estado_civil() {
    try {
      const bd: any = await this.settings.get_query(1, '/tubo-inversionista/estado-civil/', {}, true);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:
              this.estado_civil_array = body_data?.estado_civil;

          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log(bd, "CAYO EN EL CATCH")
    }
  }

  getSeleccionados(): string[] {
  const values = this.formGroup4.value; 
  const opciones = [
    "Ahorros personales",
    "Sueldo o ingresos laborales",
    "Venta de bienes",
    "Herencia o donaciones",
    "Rentas de inversiones",
    "Otros"
  ];

  return Object.keys(values)
    .filter(key => values[key] === true)
    .map(key => opciones[+key]);
  }

  getSeleccionadosJuridicos(): string[] {
  const values = this.valForm4.value; 
  const opciones = [
    "Ventas o ingresos de la empresa",
    "Capitalización de socios",
    "Préstamos o financiamiento",
    "Rentas de inversiones",
    "Otros"
  ];

  return Object.keys(values)
    .filter(key => values[key] === true)
    .map(key => opciones[+key]);
  }

  getSeleccionados2(): string[] {
  const values = this.formGroup5.value; 
  const opciones = [
    "Ley FATCA",
    "PEP",
    "información actualizada",
  ];

  return Object.keys(values)
    .filter(key => values[key] === true)
    .map(key => opciones[+key]);
  }

  continuar(){
    if(this.opcion_seleccionada == 'Persona natural'){
      this.step = 1;
    }else{
      this.step = 2;
    }
  }

  formatPhone(event: any) {
    const input = event.target.value.replace(/\D/g, '');
    this.formGroup.get('phone')?.setValue(input, { emitEvent: false });
  }

  formatPhone2(event: any) {
    const input = event.target.value.replace(/\D/g, '');
    this.valForm2.get('phone')?.setValue(input, { emitEvent: false });
  }

  formatPhoneJuridico(event: any) {
    let input = event.target.value.replace(/\D/g, '');

    this.valForm2.get('phone')?.setValue(input);
  }

  formatRUT(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }

 


    this.formGroup.controls['rut'].setValue(cleaned);
  }

  formatRUT_juridico(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }


    this.valForm.controls['rut'].setValue(cleaned);
  }

  formatRUT_juridico2(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }


    this.valForm2.controls['rut'].setValue(cleaned);
  }

  formatRUT3(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }

    this.formGroup3.controls['rut'].setValue(cleaned);
  }

  substep:any=1;
  async sendForm($ev:any) {

    $ev.preventDefault();

    for (let c in this.formGroup.controls) {
      this.formGroup.controls[c].markAsTouched();
    }

    if (this.formGroup.valid) {

      this.substep = 2;



    }else{
      console.log("form invalido")
      console.log(this.formGroup.value)
    }

  }

  async sendFormJuridico($ev:any) {

    $ev.preventDefault();

    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {

      this.substep = 2;



    }else{
      console.log("form invalido")
      console.log(this.valForm.value)
    }

  }

  show_terceros:boolean=false;
  async sendForm2($ev:any) {

    $ev.preventDefault();

    for (let c in this.formGroup2.controls) {
      this.formGroup2.controls[c].markAsTouched();
    }

    if (this.formGroup2.valid) {

      this.substep = 3;


      this.formGroup3.controls['rut'].setValue(this.formGroup.controls['rut'].value)

      if(this.formGroup3.controls['rut'].value != this.formGroup.controls['rut'].value){
        this.show_terceros = true;
        this.formGroup3.controls['autorizar_terceros'].setValue(true);

      }else{
        this.show_terceros = false;
        this.formGroup3.controls['autorizar_terceros'].setValue(false)
      }



    }else{
      console.log("form invalido")
      console.log(this.formGroup2.value)
    }

  }

  async sendFormJuridico2($ev:any) {

    $ev.preventDefault();

    for (let c in this.valForm2.controls) {
      this.valForm2.controls[c].markAsTouched();
    }

    if (this.valForm2.valid) {

      this.substep = 3;


      this.formGroup3.controls['rut'].setValue(this.valForm.controls['rut'].value)

      if(this.formGroup3.controls['rut'].value != this.valForm.controls['rut'].value){
        this.show_terceros = true;
        this.formGroup3.controls['autorizar_terceros'].setValue(true);

      }else{
        this.show_terceros = false;
        this.formGroup3.controls['autorizar_terceros'].setValue(false)
      }



    }else{
      console.log("form invalido")
      console.log(this.valForm2.value)
    }

  }

  async sendForm3($ev:any) {

    $ev.preventDefault();

    for (let c in this.formGroup3.controls) {
      this.formGroup3.controls[c].markAsTouched();
    }

    if (this.formGroup3.valid) {

      this.formGroup3.value['banco_id'] = this.formGroup3.controls['banco_id'].value.id;
      this.substep = 4;



    }else{
      console.log("form invalido")
      console.log(this.formGroup3.value)
    }

  }

  async sendFormJuridico3($ev:any) {

    $ev.preventDefault();

    for (let c in this.formGroup3.controls) {
      this.formGroup3.controls[c].markAsTouched();
    }

    if (this.formGroup3.valid) {

      this.formGroup3.value['banco_id'] = this.formGroup3.controls['banco_id'].value.id;
      this.substep = 4;



    }else{
      console.log("form invalido")
      console.log(this.formGroup3.value)
    }

  }

  sendForm4(){
    this.substep = 5;
  }

  verify_tercero(){
      if(this.formGroup3.controls['rut'].value != this.formGroup.controls['rut'].value){
        this.show_terceros = true;
        this.formGroup3.controls['autorizar_terceros'].setValue(true);

      }else{
        this.show_terceros = false;
        this.formGroup3.controls['autorizar_terceros'].setValue(false)
      }
  }

  //BANCOS
  bancos:any[]=[]
  filteredOptions!: Observable<any[]>;
  async load_bancos() {
    try {
      const bd: any = await this.settings.get_query(1, '/bank/');
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:
          for (let i = 0; i < body_data.banks.length; i++) {
            this.bancos.push(body_data.banks[i]);
          }

          this.filteredOptions = this.formGroup3.controls["banco_id"].valueChanges.pipe(
            startWith(''),
            map((value) => this.filter(value))
          );


          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log(bd, "CAYO EN EL CATCH")
    }
  }

  displayFn(option: any): string {
    return option && option.name ? option.name : '';
  }

  filter(value: any) {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value?.name?.toLowerCase() || '';

    return this.bancos.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  cuentas:any[]=[];
  async load_cuentas() {
    try {
      this.cuentas = [];
      const bd: any = await this.settings.get_query(1, '/account-type/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
        case 200:
          var body_data: any = bd._body;

          for (let i = 0; i < body_data.accounts.length; i++) {
            if (i != 1) {
              this.cuentas.push(body_data.accounts[i]);
            }
          }

          break;
        default:
          break;
      }
    } catch (bd: any) {


    }
  }

  compareFn = (o1: any, o2: any) => o1 === o2;

  origen_fondos:any=null;
  mainForm:any;
  finalizar(){

    let copia = {...this.formGroup3.value}
    copia['banco_id'] = copia?.banco_id?.id;

    let rut = this.formGroup.controls['rut'].value;
    let email = this.formGroup.controls['email'].value;


    this.mainForm = this._formBuilder.group({
      datos_personales: this.formGroup,
      informacion_laboral: this.formGroup2,
      informacion_bancaria: copia,
      origen_fondos: this.formGroup4,
      declaraciones_juradas: this.formGroup5,
      tipo_empresa: 0
    });


    this.mainForm.value['datos_personales'].rut = rut;
    this.mainForm.value['datos_personales'].email = email;
    console.log("Objeto a enviar al back", this.mainForm.value)



    this.prueba_antony(this.mainForm.value)


  }

  finalizar_juridico(){

    let copia = {...this.formGroup3.value}
    copia['banco_id'] = copia?.banco_id?.id;

    let rut = this.valForm.controls['rut'].value;
    let email = this.valForm.controls['email'].value;


    let rut_representante = this.valForm2.controls['rut'].value;

    this.mainForm = this._formBuilder.group({
      datos_empresa: this.valForm,
      representante_legal: this.valForm2,
      informacion_bancaria: this.formGroup3,
      origen_fondos: this.valForm4,
      declaraciones_juradas: this.formGroup5,
      tipo_empresa: 1
    });

    this.mainForm.value['datos_empresa'].rut = rut;
    this.mainForm.value['datos_empresa'].email = email;
    this.mainForm.value['representante_legal'].rut = rut_representante;

    this.prueba_antony2(this.mainForm.value)


  }

  block_button:boolean=false;
  async prueba_antony(value:any){
      this.block_button = true;
      try {
      const bd: any = await this.settings.get_query(3, '/tubo-inversionista/editar-info-empresa/'+this.selectedTuboId+'/', value);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:

        this.success();
        this.block_button = false;


          break;
        default:
          break;
      }
    } catch (bd: any) {

        console.error(bd.error.message)
        let error = bd?.error?.message;
        if(error.includes('Falta campo en informacion_bancaria')){
          this.dialog.open(DialogStatus, {
            autoFocus: false,
            panelClass: 'small-dialog',
            width: '700px',
            data: {
              title: 'Falta información',
              message: 'Faltan los datos de cuenta bancaria.',
              type: 'error'
            }
          });
        }

      this.block_button = false;

    } finally {
      this.block_button = false;
    }
  }

  async prueba_antony2(value:any){

      this.block_button = true;
      try {
      const bd: any = await this.settings.get_query(3, '/tubo-inversionista/editar-info-empresa/'+this.selectedTuboId+'/', value);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:

          this.success();

          break;
        default:
          break;
      }
    } catch (bd: any) {

      console.error(bd.error.message)
      let error = bd?.error?.message;
      if(error.includes('Falta campo en informacion_bancaria')){
        this.dialog.open(DialogStatus, {
          autoFocus: false,
          panelClass: 'small-dialog',
          width: '700px',
          data: {
            title: 'Falta información',
            message: 'Faltan los datos de cuenta bancaria.',
            type: 'error'
          }
        });
      }

    } finally {
      this.block_button = false;
    }
  }

  soloNumerosCuenta(): void {
    const control = this.formGroup3.get('numero_cuenta');
    if (!control) return;

    let valor = control.value ?? '';

    valor = valor.toString().replace(/\D+/g, '');

    if (valor.length > 30) {
      valor = valor.substring(0, 30);
    }

    control.setValue(valor, { emitEvent: false });
  }

  async get_ficha(){

    console.log("get ficha")
      try {
      this.loading = true;
      const bd: any = await this.settings.get_query(1, '/tubo-inversionista/info-empresa/'+this.selectedTuboId+'/');
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:




            const tipo_company = body_data?.info?.tipo_empresa;
            if(tipo_company == 0){
              this.step = 1;
            }else if(tipo_company == 1){
              this.step = 2;
            }else{
              this.step = 0;
            }

            console.log("tipo empresa", tipo_company)

            const datos_personales = body_data?.info?.datos_personales;
            const informacion_laboral = body_data?.info?.informacion_laboral;
            const origen_fondos = body_data.info?.origen_fondos;
            const informacion_bancaria = body_data?.info?.informacion_bancaria;
            const declaraciones_juradas = body_data?.info?.declaraciones_juradas;

            const datos_empresa = body_data?.info?.datos_empresa;
            const representante_legal = body_data?.info?.representante_legal;

            console.log(tipo_company)

            //Persona natural
            if(tipo_company == 0){


              this.formGroup.controls['rut'].setValue(datos_personales?.rut);
              this.formGroup.controls['name'].setValue(datos_personales.name);
              this.formGroup.controls['fecha_nacimiento'].setValue(new Date(datos_personales.fecha_nacimiento));
              this.formGroup.controls['nacionalidad'].setValue(datos_personales.nacionalidad);
              // this.formGroup.controls['phone'].setValue(datos_personales.phone);
              this.formGroup.controls['email'].setValue(datos_personales.email);
              this.formGroup.controls['direccion'].setValue(datos_personales.direccion);

              this.formGroup.controls['estado_civil'].setValue(datos_personales.estado_civil);

              this.formGroup2.controls['situacion_laboral'].setValue(informacion_laboral.situacion_laboral);
              this.formGroup2.controls['business_name'].setValue(informacion_laboral.business_name);
              this.formGroup2.controls['profesion'].setValue(informacion_laboral.profesion);

              this.formGroup.controls['region_id'].setValue(datos_personales.region_id);
              this.formGroup.controls['comuna_id'].setValue(datos_personales.comuna_id);

              this.formGroup4.controls[0].setValue(origen_fondos['0']);
              this.formGroup4.controls[1].setValue(origen_fondos['1']);
              this.formGroup4.controls[2].setValue(origen_fondos['2']);
              this.formGroup4.controls[3].setValue(origen_fondos['3']);
              this.formGroup4.controls[4].setValue(origen_fondos['4']);
              this.formGroup4.controls[5].setValue(origen_fondos['5']);

              this.loadDatosPersonales(datos_personales)

            }

            //Persona juridica
            if(tipo_company == 1){

              this.valForm.controls['rut'].setValue(datos_empresa.rut);
              this.valForm.controls['razon_social'].setValue(datos_empresa.razon_social);
              this.valForm.controls['direccion'].setValue(datos_empresa.direccion);
              this.valForm.controls['giro'].setValue(datos_empresa.giro);
              this.valForm.controls['email'].setValue(datos_empresa.email);

              this.valForm2.controls['rut'].setValue(representante_legal.rut);
              this.valForm2.controls['name'].setValue(representante_legal.name);
              this.valForm2.controls['fecha_nacimiento'].setValue(representante_legal.fecha_nacimiento);
              this.valForm2.controls['nacionalidad'].setValue(representante_legal.nacionalidad);
              // this.valForm2.controls['phone'].setValue(representante_legal.phone);
              this.valForm2.controls['email'].setValue(representante_legal.email);
              this.valForm2.controls['direccion'].setValue(representante_legal.direccion);
              this.valForm2.controls['cargo'].setValue(representante_legal.cargo);
              this.valForm2.controls['estado_civil'].setValue(representante_legal.estado_civil);
              this.valForm2.controls['region_empresa_id'].setValue(representante_legal.region_empresa_id);
              this.valForm2.controls['comuna_empresa_id'].setValue(representante_legal.comuna_empresa_id);
              this.valForm2.controls['profesion'].setValue(representante_legal.profesion);

              this.valForm4.controls[0].setValue(origen_fondos['0']);
              this.valForm4.controls[1].setValue(origen_fondos['1']);
              this.valForm4.controls[2].setValue(origen_fondos['2']);
              this.valForm4.controls[3].setValue(origen_fondos['3']);
              this.valForm4.controls[4].setValue(origen_fondos['4']);

              this.loadDatosempresa(representante_legal)

            }

            //AMBOS
            this.formGroup3.controls['banco_id'].setValue(
              this.bancos.find(o => o.id === informacion_bancaria.banco_id)
            );

            this.formGroup3.controls['cuenta_id'].setValue(informacion_bancaria.cuenta_id);
            this.formGroup3.controls['rut'].setValue(informacion_bancaria.rut);
            this.formGroup3.controls['titular'].setValue(informacion_bancaria.titular);
            this.formGroup3.controls['numero_cuenta'].setValue(informacion_bancaria.numero_cuenta);
            this.formGroup3.controls['autorizar_terceros'].setValue(informacion_bancaria.autorizar_terceros);

            if(this.formGroup3.controls['autorizar_terceros'].value == true){
              this.show_terceros = true;
            }

            //AMBOS
            this.formGroup5.controls[0].setValue(declaraciones_juradas['0']);
            this.formGroup5.controls[1].setValue(declaraciones_juradas['1']);
            this.formGroup5.controls[2].setValue(declaraciones_juradas['2']);





          break;
        default:
          break;
      }
    } catch (bd: any) {

      console.error(bd)

      this.loading = false;

    } finally {
      this.loading = false;
    }
  }

  loadDatosPersonales(datos_personales: any) {

    this.formGroup.controls['phone_code'].setValue(
      datos_personales.phone_code ?? '+56'
    );
    
    this.formGroup.controls['phone_number'].setValue(datos_personales.phone_number);
  }

  loadDatosempresa(datos_empresa: any) {

    this.valForm2.controls['phone_code'].setValue(
      datos_empresa.phone_code ?? '+56'
    );
    
    this.valForm2.controls['phone_number'].setValue(datos_empresa.phone_number);
  }

  success(){
    this.dialog.open(DialogStatus, {
      autoFocus: false,
      panelClass: 'small-dialog',
      width: '700px',
      data: {
        title: 'Ficha actualizada',
        message: 'Se actualizo la información de la ficha del inversionista exitosamente.',
        type: 'success'
      }
    });
  }

  actualizar(){

    //actualizar natuiral
    if(this.step == 1){
      this.finalizar()
    }

    //actualizar juridico
    if(this.step == 2){
      this.finalizar_juridico()
    }

  }


  regions: any[] = [];
  districts: any[] = [];
  filteredDistricts: any[] = [];
  async getDistricts(){
    try {

      const bd: any = await this.settings.get_query(1, "/address-info-form/");
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:
          this.districts = body_data.success.comunas;
          this.regions = body_data.success.regiones;

          this.formGroup.get('region_id')?.valueChanges.subscribe((regionId) => {
            this.filteredDistricts = this.districts.filter(d => d.region_id === regionId);
            //this.formGroup.get('district')?.reset();
          });

          this.valForm2.get('region_empresa_id')?.valueChanges.subscribe((regionId) => {
            this.filteredDistricts = this.districts.filter(d => d.region_id === regionId);
            //this.formGroup.get('district')?.reset();
          });

        break;

        default:
        break;
      }

    } catch (bd:any) {
      console.log(bd);
    }
  }

  get fullPhone(): string {
    const code = this.formGroup.get('phone_code')?.value ?? '';
    const number = this.formGroup.get('phone_number')?.value ?? '';
    return `${code}${number}`;
  }

  COUNTRIES: Country[]=[];
  filteredCountries: Country[] = [];
  async getPhonePrefix(){
    try {

      const bd: any = await this.settings.get_query(1, "backoffice/phone-prefixes/");
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:


          this.COUNTRIES = body_data.info;
          this.filteredCountries = [...this.COUNTRIES];

        break;

        default:
        break;
      }

    } catch (bd:any) {
      console.log(bd);
    }
  }
  

}


interface Country {
  name: string;
  flag: string;
  dialCode: string;
  code: string;
}